var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 541,
    viewBox: "0 0 548 541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 548,
    height: 541,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.596 278V199.81H196.292C205.451 199.81 212.972 201.448 218.855 204.725C224.812 207.927 229.206 212.47 232.036 218.352C234.94 224.161 236.392 231.012 236.392 238.905C236.392 246.799 234.94 253.687 232.036 259.57C229.206 265.378 224.812 269.92 218.855 273.197C212.972 276.399 205.451 278 196.292 278H169.596ZM183.893 265.713H195.622C202.175 265.713 207.35 264.671 211.148 262.585C214.946 260.426 217.664 257.373 219.302 253.426C220.94 249.405 221.759 244.565 221.759 238.905C221.759 233.32 220.94 228.517 219.302 224.496C217.664 220.475 214.946 217.384 211.148 215.225C207.35 213.065 202.175 211.985 195.622 211.985H183.893V265.713Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.94 325.212L280.865 226.022H294.828L266.791 325.212H252.94Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.178 339.592L337.774 261.403H353.858L382.453 339.592H367.262L361.007 321.497H330.513L324.146 339.592H309.178ZM334.423 310.327H357.098L345.704 277.822L334.423 310.327Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 46,
    width: 10,
    height: 80,
    transform: "rotate(90 126 46)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 10,
    height: 80,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 410,
    width: 10,
    height: 80,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 490,
    width: 10,
    height: 80,
    transform: "rotate(-90 46 490)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 490,
    width: 10,
    height: 80,
    transform: "rotate(-90 423 490)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 503,
    y: 490,
    width: 10,
    height: 80,
    transform: "rotate(-180 503 490)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 503,
    y: 126,
    width: 10,
    height: 80,
    transform: "rotate(-180 503 126)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 503,
    y: 46,
    width: 10,
    height: 80,
    transform: "rotate(90 503 46)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDa);
export default __webpack_public_path__ + "static/media/da.f2be8f8099b68d7b1787bf9f889a764b.svg";
export { ForwardRef as ReactComponent };